export function getAll() {
  let items = [
    {
      value: 1,
      text: undefined,
    },
    {
      value: 2,
      text: undefined,
    },
    {
      value: 3,
      text: undefined,
    },
    {
      value: 4,
      text: undefined,
    },
    {
      value: 5,
      text: undefined,
    },
    {
      value: 6,
      text: undefined,
    },
  ];

  const n = new Date();
  let year = n.getFullYear();
  let month = n.getMonth() + 1;
  const mod = month % 2;

  if (mod !== 0) {
    month += 1;
  }
  for (let i = 0; i < items.length; i++) {
    if (month - 2 * items[i].value > 0) {
      if (month - 2 * items[i].value < 10) {
        items[i].text = `${year - 1911}0${month - 2 * items[i].value}`;
      } else {
        items[i].text = `${year - 1911}${month - 2 * items[i].value}`;
      }
    } else {
      if (month - 2 * items[i].value + 12 < 10) {
        items[i].text = `${year - 1912}0${month - 2 * items[i].value + 12}`;
      } else {
        items[i].text = `${year - 1912}${month - 2 * items[i].value + 12}`;
      }
    }
  }

  return items;
}
